define('glu/grid/footer/bulkActions',['require','../../itemView','../../model','hbs!./bulkActions.hbs','../../util'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        Model = require('../../model'),
        tpl = require('hbs!./bulkActions.hbs'),
        util = require('../../util');

    return ItemView.extend({
        template: tpl,

        appEvents: {
            'grid:selectRow': 'initActions',
            'grid:selectAllRows': 'initActions'
        },

        modelEvents: {
            change: 'render'
        },

        events: {
            'click button': 'bulkActionHandler'
        },

        initialize: function(options) {
            options = options || {};
            this.model = new Model();
            this.columns = options.columns;
            this.bulkActions = options.bulkActions;
            this.gridCid = options.gridCid;
            this.getSelectedRows = options.getSelectedRows;
            this.getSelectedRowModels = options.getSelectedRowModels;
            this.listenTo(this.columns, 'change:condition reset', this.initActions);

            this.initActions();
        },

        onRender: function() {
            this.toggleBulkActionsVisibility();
        },

        toggleBulkActionsVisibility: function() {
            this.$el.toggleClass('bulk-actions', this.model.get('showBulkActions'));
        },

        initActions: function() {
            var bulkActions = this.bulkActions || this.getBulkActionsFromRowButtons(),
                hasRowSelector = this.hasVisibleRowSelector();

            this.model.set({
                showBulkActions: (bulkActions && bulkActions.length > 0 && hasRowSelector),
                bulkActions: bulkActions,
                bulkActionsDisabled: !this.getSelectedRows().length
            });
        },

        hasVisibleRowSelector: function() {
            return this.columns.reduce(function(visibleRowSelector, column) {
                var condition = column.get('condition'),
                    //it seems rare that one would have a function for a column level condition as showing and hiding the column would
                    //replace the function with a boolean in manageColumnsDialog.js, however row.js tests for this.
                    //We cannot pass a model here like it does as this is for all rows not just one
                    visible = !!(util.isFunction(condition) ? condition() : condition !== false);

                return visibleRowSelector || (column.get('type') === 'rowSelector' && visible);
            }, false);
        },

        getBulkActionsFromRowButtons: function() {
            return this.columns.reduce(function(bulkActions, column) {
                var rowButtons = column.get('rowButtons');

                if (!util.isArray(rowButtons)) {
                    rowButtons = [];
                }

                rowButtons.forEach(function(rowButton) {
                    if (!rowButton.header && !rowButton.separator && (rowButton.supportsBulkAction || rowButton.bulkActionOnly)) {
                        bulkActions.push(rowButton);
                    }
                });

                return bulkActions;
            }, []);
        },

        bulkActionHandler: function(event) {
            var index = this.$(event.target).data('index'),
                action = this.model.get('bulkActions')[index],
                result;

            event.preventDefault();

            if (action && action.handler) {
                result = action.handler(this.getSelectedRowModels());

                this.appBus.trigger('grid:bulkActionHandled', this.gridCid, action, result);
            }
        }
    });
});

